<template>
  <div>
    <qx-card title="申请ETC卡" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />
      <!-- 订单详情数据 end -->
    </qx-card>
    <applyForm />
  </div>
</template>

<script>
import {
  applyCardDetail, // 获取详情
} from 'api/service';
import applyForm from './applyForm';
export default {
  components: {
    applyForm,
  },
  data () {
    return {
      loading: false,
      detailData: {
        base: {
          label: '产品信息',
          tableData: {
            title: [
              {
                prop: 'etcCardTypeName',
                label: '卡类型',
              },
              {
                prop: 'paymentTypeName',
                label: '付费类型',
              },
              {
                prop: 'useScopeName',
                label: '适用范围',
              },
              {
                prop: 'productName',
                label: '产品名称',
              },
              {
                prop: 'serviceCall',
                label: '服务电话',
              },
              {
                prop: 'discountRemark',
                label: '优惠说明',
              },
              {
                prop: 'introduce',
                label: '产品简介',
              },
              {
                prop: 'accountPeriodRemark',
                label: '账期',
              },
              {
                prop: 'serviceCharge',
                label: '服务费',
              },
              {
                prop: 'statementDateRemark',
                label: '账单日',
              },
              {
                prop: 'repaymentDateRemark',
                label: '还款日',
              },
              {
                prop: 'lateFeeRemark',
                label: '滞纳金',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  methods: {
    async getData () {
      if (this.$route.path !== '/manage/service/site/applyEtcCard') {
        return;
      }
      this.loading = true;
      const detailRes = await applyCardDetail({
        productId: this.$route.query.productId,
        isShare: this.$route.query.isShare,
        tenantId: this.$route.query.tenantId,
      });
      this.loading = false;
      if (!detailRes.failed) {
        this.detailData.base.tableData.data = {
          ...detailRes.etcProductData,
          ...detailRes.productData,
        };
      }
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import "styles/config.scss";
.orderStatusBox{
  overflow: auto;
}
.orderInfoBox{
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title{
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,.time{
    color: #666;
    line-height: 16px;
  }
  .desc{
    padding-bottom: 12px;
  }
}
.box{
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel{
  background: $grey;
}
.itemLabel,.itemText{
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
